import React, { useState, useEffect } from 'react';
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import { useQuoteContext, updateForm } from '../QuoteContext';
import Header from '../components/Header';
import { Modal } from 'semantic-ui-react';

export default function Services(props) {
  const { form, dispatch } = useQuoteContext();
  const [open, setOpen] = React.useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [services, setServices] = useState([]);

  const navigate = useNavigate();

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;

    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let serviceExists = services.filter((service) => service === value);
    if (serviceExists.length > 0)
      return setServices(services.filter((service) => service !== value));
    return setServices([...services, value]);
  };

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();
  console.log(query.get('vehicleModel'));
  console.log(services);
  console.log(form);
  return (
    <div>
      <Modal
        className="!w-10/12 sm:w-1/2 lg:w-1/3 !rounded-md"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <div className="!border-none !font-black !uppercase px-5 py-3 text-xl">
          No Services Selected
        </div>
        <div className="px-5 pb-3 text-md">
          <p>You must select at least one service to receive a free quote.</p>
        </div>
        <Modal.Actions className="!border-none">
          <button
            onClick={() => setOpen(false)}
            class="w-full py-2 mb-5 !bg-[#010739] rounded-md text-white uppercase font-semibold text-lg tracking-wide my-1"
          >
            Okay
          </button>
        </Modal.Actions>
      </Modal>
      <Header title={'Services'} />

      <div className="bg-[#FFFFFF] text-[#090F27] w-screen flex justify-center pb-20">
        <div className="w-10/12 sm:w-1/2 lg:w-1/3 text-left">
          <div className="mt-3 pb-5">
            { 
              query.get('vehicleMake') !== "null" && query.get('vehicleMake') !== null ?
              (<h2 className="font-oswald font-bold text-2xl">
              How can we help with your {query.get('vehicleMake') || null}{' '}
              {query.get('vehicleModel') || null}?
            </h2>)
              : (
                <h2 className="font-oswald font-bold text-2xl">
              How can we help you?
            </h2>
              )
            }
            <p className="font-raleway pt-5">Please select which services you need:</p>
          </div>

          <div class="accordion accordion-flush font-raleway" id="accordionFlushExample">
            <div class="accordion-item border-t-0 border-l-0 border-r-0 rounded-none bg-white border border-gray-200">
              <h2 class="accordion-header mb-0 font-oswald" id="flush-headingOne">
                <button
                  class="accordion-button relative flex items-center w-full py-4 px-0 text-base !text-[#010739] font-bold text-left bg-white border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  <svg
                    className="inline relative -left-2"
                    fill="#010739"
                    width="40pt"
                    height="40pt"
                    version="1.1"
                    viewBox="0 0 752 752"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path d="m345.64 493.3-22.699-13.109 22.699-13.109c4.5312-2.6172 6.082-8.4062 3.4648-12.938-2.6133-4.5273-8.4062-6.082-12.938-3.4648l-21.73 12.547v-25.656c0-5.2266-4.2422-9.4727-9.4727-9.4727-5.2266 0-9.4727 4.2422-9.4727 9.4727v26.777l-23.68-13.672c-4.5312-2.6172-10.328-1.0664-12.938 3.4609-2.6133 4.5352-1.0664 10.332 3.4688 12.938l22.703 13.117-22.703 13.109c-4.5312 2.6172-6.082 8.4062-3.4648 12.938 1.7539 3.0469 4.9336 4.7344 8.2109 4.7344 1.6055 0 3.2344-0.40625 4.7266-1.2695l23.68-13.676-0.003906 26.789c0 5.2266 4.2422 9.4727 9.4727 9.4727 5.2266 0 9.4727-4.2422 9.4727-9.4727v-25.652l21.734 12.547c1.4922 0.86328 3.1211 1.2695 4.7266 1.2695 3.2734 0 6.4609-1.6914 8.2109-4.7344 2.6172-4.5391 1.0625-10.328-3.4688-12.945z" />
                      <path d="m487.72 493.3-22.703-13.109 22.703-13.109c4.5273-2.6172 6.082-8.4062 3.4648-12.938-2.6289-4.5273-8.4023-6.0859-12.938-3.4648l-21.734 12.547v-25.656c0-5.2266-4.2422-9.4727-9.4727-9.4727-5.2266 0-9.4727 4.2422-9.4727 9.4727v26.777l-23.68-13.672c-4.5469-2.625-10.324-1.0664-12.938 3.4609-2.6133 4.5352-1.0586 10.332 3.4688 12.938l22.703 13.117-22.703 13.109c-4.5273 2.6172-6.082 8.4062-3.4648 12.938 1.7578 3.0469 4.9375 4.7344 8.2109 4.7344 1.6055 0 3.2383-0.40625 4.7266-1.2695l23.68-13.676-0.003906 26.789c0 5.2266 4.2422 9.4727 9.4727 9.4727 5.2266 0 9.4727-4.2422 9.4727-9.4727v-25.652l21.738 12.547c1.4883 0.86328 3.1211 1.2695 4.7266 1.2695 3.2734 0 6.4531-1.6914 8.2109-4.7344 2.6133-4.5391 1.0586-10.328-3.4688-12.945z" />
                      <path d="m475.45 276.55h-99.453c-5.2266 0-9.4727-4.2422-9.4727-9.4727 0-5.2266 4.2422-9.4727 9.4727-9.4727h99.453c5.2266 0 9.4727 4.2422 9.4727 9.4727 0 5.2266-4.2422 9.4727-9.4727 9.4727z" />
                      <path d="m537.02 276.55h-23.68c-5.2266 0-9.4727-4.2422-9.4727-9.4727 0-5.2266 4.2422-9.4727 9.4727-9.4727h23.68c5.2266 0 9.4727 4.2422 9.4727 9.4727 0 5.2266-4.2461 9.4727-9.4727 9.4727z" />
                      <path d="m555.96 210.25h-359.92c-18.234 0-33.152 14.918-33.152 33.152v132.6c0 18.234 14.918 33.152 33.152 33.152h359.92c18.234 0 33.152-14.918 33.152-33.152v-132.61c0-18.234-14.918-33.148-33.152-33.148zm-336.24 179.96 5.3945-29.797c0.26953-1.3789 2.6758-3.3516 4.0781-3.3516h293.62c1.4023 0 3.8125 1.9766 4.0781 3.3477l5.3906 29.801zm350.45-14.207c0 7.832-6.375 14.207-14.207 14.207h-4.7344l-5.7578-33.516c-2.0391-10.215-12.238-18.578-22.656-18.578h-293.62c-10.418 0-20.613 8.3594-22.66 18.574l-5.7539 33.52h-4.7344c-7.832 0-14.207-6.375-14.207-14.207l-0.003907-132.6c0-7.832 6.375-14.207 14.207-14.207h359.92c7.832 0 14.207 6.375 14.207 14.207z" />
                    </g>
                  </svg>
                  Auto A/C Repair Services
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                class="accordion-collapse border-0 collapse show"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body py-4 px-5 h-1/4">
                  {acServices.map((service, index) => (
                    <div class="form-check py-4">
                      <input
                        className="h-5 w-5 border-[3px]  border-gray-600 rounded-[3px] bg-white checked:!bg-[#010739] checked:!border-[#010739] focus:!ring-[#010739] focus:!text-[#010739] focus:outline-none focus: transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-5 cursor-pointer"
                        type="checkbox"
                        value={service.value}
                        id={`flexCheckDefault${index}`}
                        name={service.name}
                        onChange={(e) => handleChange(e)}
                      />
                      <label
                        className="form-check-label inline-block text-gray-800 text-md cursor-pointer"
                        htmlFor={`flexCheckDefault${index}`}
                      >
                        {service.name}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div class="accordion-item border-l-0 border-r-0 rounded-none bg-white border border-gray-200">
              <h2 class="accordion-header mb-0 font-oswald" id="flush-headingTwo">
                <button
                  class="accordion-button relative flex items-center w-full py-4 px-0 text-base !text-[#010739] font-bold text-left bg-white border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  <svg
                    className="inline relative -left-2"
                    fill="#010739"
                    width="40pt"
                    height="40pt"
                    version="1.1"
                    viewBox="0 0 752 752"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m352.32 177.1c-96.664 0-175.23 78.562-175.23 175.23 0 82.859 57.711 152.03 135.12 170.19 2.4609 0.60156 5.0547 0.19922 7.2188-1.1172 2.1602-1.3164 3.707-3.4414 4.2969-5.9023 0.58984-2.4609 0.17578-5.0547-1.1523-7.2109-1.3281-2.1523-3.457-3.6914-5.9219-4.2695-69.043-16.199-120.62-77.625-120.62-151.69 0-86.426 69.859-156.29 156.29-156.29 84.82 0 153.61 67.344 156.13 151.55h-23.531c-0.29688-0.011719-0.59375-0.011719-0.89062 0-4.8789 0.46094-8.6016 4.5703-8.582 9.4727v11.84c0 59.734-54.113 111.29-118.39 111.29-5.2305 0.003906-9.4727 4.2422-9.4727 9.4727v75.773h0.14844c0.019531 0.44531 0.066406 0.89062 0.14844 1.332 0.11328 0.91797 0.36328 1.8164 0.73828 2.6641 0.83203 1.7422 2.1758 3.1875 3.8477 4.1445 0.78516 0.46484 1.6328 0.8125 2.5156 1.0352 0.67969 0.17578 1.375 0.27344 2.0742 0.29688 0.29688-0.035156 0.59375-0.085938 0.88672-0.14844 119.49-0.46875 216.96-92.18 216.96-205.86 0-4.207-0.1875-8.3516-0.44531-12.434-0.3125-4.9961-4.4648-8.8867-9.4727-8.8789h-37.59c-2.5586-94.441-80.023-170.49-175.07-170.49zm0 80.508c-52.199 0-94.719 42.52-94.719 94.719 0 52.195 42.52 94.715 94.719 94.715 52.195 0 94.715-42.52 94.715-94.715 0-52.199-42.52-94.719-94.715-94.719zm0 18.945c41.957 0 75.77 33.812 75.77 75.773 0 41.957-33.812 75.77-75.77 75.77-41.961 0-75.773-33.812-75.773-75.77 0-41.961 33.812-75.773 75.773-75.773zm-34.188 23.676c-2.0781 0.17188-4.1562 0.82422-6.0703 1.9258-6.793 3.9219-9.1016 12.594-5.1797 19.387 3.9258 6.793 12.594 9.1055 19.391 5.1797 6.793-3.9219 9.1016-12.594 5.1797-19.387-2.4531-4.2461-6.6992-6.7812-11.25-7.1055-0.68359-0.046874-1.3789-0.054687-2.0703 0zm66.301 0c-4.5508 0.32422-8.7969 2.8594-11.246 7.1055-3.9258 6.793-1.6172 15.465 5.1797 19.387 6.793 3.9258 15.465 1.6133 19.387-5.1797 3.9219-6.793 1.6133-15.465-5.1797-19.387-2.5508-1.4727-5.4102-2.1172-8.1406-1.9258zm-32.113 33.152c-10.465 0-18.945 8.4805-18.945 18.945 0 10.461 8.4805 18.941 18.945 18.941 10.461 0 18.941-8.4805 18.941-18.941 0-10.465-8.4805-18.945-18.941-18.945zm142.07 33.152h61.414c0.011719 0.78906 0.14844 1.5781 0.14844 2.3672 0 43.051-15.52 82.738-41.586 114.25l-14.355-10.656c-1.7383-1.3203-3.8828-2-6.0664-1.9219-4.0508 0.14453-7.5625 2.8477-8.7344 6.7305-1.168 3.8789 0.25781 8.0742 3.5547 10.438l12.727 9.4688c-34.188 33.781-81.797 55.484-134.97 57.867v-56.977c13.305-0.92188 26.223-3.6328 38.328-7.9922l15.836 19.684c3.2695 4.0859 9.2344 4.75 13.32 1.4805s4.75-9.2344 1.4805-13.32l-12.73-15.836c28.016-14.73 50.434-38.336 62.309-66.746l18.645 11.25c2.1445 1.5938 4.8594 2.2109 7.4766 1.6992 2.6211-0.51172 4.9062-2.1055 6.2891-4.3906 1.3828-2.2852 1.7383-5.0469 0.97656-7.6055-0.76172-2.5586-2.5664-4.6797-4.9727-5.8359l-22.496-13.469c2.1953-9.0547 3.4062-18.484 3.4062-28.117zm-176.26 9.4688c-4.5508 0.32422-8.7969 2.8594-11.25 7.1055-3.9219 6.793-1.6133 15.465 5.1797 19.387 6.7969 3.9219 15.465 1.6133 19.391-5.1797 3.9219-6.793 1.6133-15.465-5.1797-19.387-2.5508-1.4727-5.4141-2.1172-8.1406-1.9258zm66.301 0c-2.0781 0.17188-4.1562 0.82031-6.0664 1.9258-6.7969 3.9219-9.1055 12.594-5.1797 19.387 3.9219 6.793 12.59 9.1016 19.387 5.1797 6.793-3.9219 9.1016-12.594 5.1797-19.387-2.4531-4.2461-6.6992-6.7812-11.25-7.1055-0.67969-0.046875-1.3789-0.054688-2.0703 0z" />
                  </svg>
                  Brake Repair Services
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                class="accordion-collapse border-0 collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body py-4 px-5">
                  {brakeServices.map((service, index) => (
                    <div class="form-check py-4">
                      <input
                        className="h-5 w-5 border-[3px]  border-gray-600 rounded-[3px] bg-white checked:!bg-[#010739] checked:!border-[#010739] focus:!ring-[#010739] focus:!text-[#010739] focus:outline-none focus: transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-5 cursor-pointer"
                        type="checkbox"
                        value={service.value}
                        id={`flexCheckDefault${service + index}`}
                        name={service.name}
                        onChange={handleChange}
                      />
                      <label
                        className="form-check-label inline-block text-gray-800 text-md cursor-pointer"
                        htmlFor={`flexCheckDefault${service + index}`}
                      >
                        {service.name}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="w-screen bg-[#F8F8F8] border-t border-[#737373] py-2 z-50 fixed bottom-0 h-20 flex flex-row justify-center">
        <button
          class="font-oswald w-10/12 sm:w-1/2 lg:w-1/3 !bg-[#010739] rounded-md text-white uppercase font-semibold text-lg tracking-wide my-1"
          tabindex="0"
          type="submit"
          onClick={() => {
            if (services.length === 0) return setOpen(true);
            dispatch(
              updateForm({
                ...form,
                vehicleYear: query.get('vehicleYear'),
                vehicleMake: query.get('vehicleMake'),
                vehicleModel: query.get('vehicleModel'),
                services: services
              })
            );
            return navigate(
              `/get-a-quote/add-info?vehicleYear=${query.get(
                'vehicleYear'
              )}&vehicleMake=${query.get(
                'vehicleMake'
              )}&vehicleModel=${query.get('vehicleModel')}`
            );
          }}
        >
          Wrap Up My Quote
        </button>
      </footer>
    </div>
  );
}

const acServices = [
  { name: 'AC Diagnostic', value: 'AC Diagnostic' },
  { name: 'AC Evacuation & Recharge', value: 'AC Evacuation & Recharge' },
  { name: 'AC Condenser Replacement', value: 'AC Condenser Replacement' },
  {
    name: 'AC Condenser Fan Replacement',
    value: 'AC Condenser Fan Replacement'
  },
  { name: 'AC Compressor Replacement', value: 'AC Compressor Replacement' },
  { name: 'AC Evaporator Replacement', value: 'AC Evaporator Replacement' }
];

const brakeServices = [
  { name: 'Brake Pad Replacement', value: 'Brake Pad Replacement' },
  { name: 'Brake Rotor Replacement', value: 'Brake Rotor Replacement' },
  { name: 'Brake Shoe Replacement', value: 'Brake Shoe Replacement' },
  {
    name: 'Brake Caliper Replacement',
    value: 'Brake Caliper Replacement'
  }
];
